import { motion } from "framer-motion";

const STATS = [
  { value: "500+", label: "Orders shipped" },
  { value: "36", label: "Nigerian states" },
  { value: "7–10", label: "Day delivery" },
  { value: "2011", label: "Trusted since" },
];

export default function TrustBand() {
  return (
    <section
      data-testid="trust-band"
      className="bg-[#0A0A0A] text-[#F8F5F0] border-y border-[#C9A96E]/20"
    >
      <div className="container-mps py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="text-center md:border-r md:last:border-r-0 border-[#C9A96E]/15"
              data-testid={`trust-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="font-serif text-4xl md:text-5xl text-[#C9A96E]">
                {s.value}
              </div>
              <div className="overline mt-3 text-[#F8F5F0]/70">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
